import React from "react";
import styles from "./productDetails.module.scss";
import productImage from "../../../assets/images/productImg.jpg";
import { Paper } from "@mui/material";
import StatusCard from "../statusCard/StatusCard";
import { connect } from "react-redux";
import { getObjectFromArrayOfObjects } from "../../../utils/common/CommonFunctions";
import { Item } from "devextreme-react/data-grid";

const ProductDetails = ({ product = {}, categories }) => {
  const getCategory = () => {
    console.log("product", product);
    console.log(categories);
    const name = console.log("name", name);
  };
  return (
    <div className={styles.container}>
      <Paper elevation={2} classes={{ root: styles.wrapper }}>
        {" "}
        <div className={styles.imgContainer}>
          <div className={styles.imageWrapper}>
            <img
              src={product?.imageUrl || ""}
              alt="Product"
              className={styles.productImage}
            />
          </div>
        </div>
        <div className={styles.detailsWrapper}>
          <div className={styles.left}>
            <div className={styles.row}>
              <div className={styles.label}>Product ID</div>
              <div className={styles.value}>: {product?.id}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>Product Name</div>
              <div className={styles.value}>: {product?.name}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>Description</div>
              <div className={styles.value}>:{product?.description}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>Category</div>
              <div className={styles.value}>
                :
                {
                  getObjectFromArrayOfObjects(
                    categories,
                    "id",
                    product?.categoryId[0]
                  )?.name
                }
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>Status</div>
              <div className={styles.value}>
                : {product?.quantity > 0 ? "InStock" : "OutOfStock"}
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>HSN</div>
              <div className={styles.value}>: {product?.hsnCode}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>GST</div>
              <div className={styles.value}>: {product?.gst}%</div>
            </div>
          </div>
          <div className={styles.right}>
            <div className={styles.row}>
              <div className={styles.label}>Price</div>
              <div className={styles.value}>: ₹{product?.price}</div>
            </div>

            <div className={styles.row}>
              <div className={styles.label}>Weight</div>
              <div className={styles.value}>: {product?.weight}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>Quantity</div>
              <div className={styles.value}>: {product?.quantity}</div>
            </div>

            <div className={styles.row}>
              <div className={styles.label}>SKU</div>
              <div className={styles.value}>: {product?.skuId}</div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>User Notified</div>
              <div className={styles.value}>
                :{" "}
                {product?.notifyCus === null
                  ? "NA"
                  : product?.notifyCus?.length}
              </div>
            </div>
            <div className={styles.row}>
              <div className={styles.label}>Keywords</div>
              <div className={styles.value}>
                : {product?.keywords?.join(", ")}
              </div>
            </div>
          </div>
        </div>
      </Paper>

      <Paper elevation={2} classes={{ root: styles.wrapper }}>
        <div className={styles.descriptionWrapper}>
          <div className={styles.descriptionTitle}>DETAILED DESCRIPTION</div>
          {/* <div className={styles.descriptionSubtitle}>Rorem Ipsum Dolor</div> */}
          <div className={styles.descriptionText}>
            {product?.detailDescription}
          </div>
          {/* <div className={styles.descriptionPoint}>100% natural</div>
          <div className={styles.descriptionPoint}>
            High in calcium and protein
          </div>
          <div className={styles.descriptionPoint}>
            Lactose-friendly and easy to digest
          </div> */}
        </div>
      </Paper>
    </div>
  );
};

const mapStateToProps = (state, props) => {
  return {
    product: state?.product?.product,
    categories: state?.category?.categories,
  };
};

export default connect(mapStateToProps, null)(ProductDetails);
